import { entitiesApi } from '@tunasong/redux'
import type { Chat, ChatAction, Comment, Persisted } from '@tunasong/schemas'

/**
 * Tasks, likes and thread resolve from the client (GH #3041, #2796). Each posts one action to
 * `POST /entities/{id}/chat-actions`, which anyone who can comment may call; the server's version of the comment or
 * thread replaces the cached one. Each resolves `false` when the action failed, so the caller can say so.
 */
export const useChatActions = () => {
  const [chatAction] = entitiesApi.useChatActionMutation()

  const run = async (id: string, action: ChatAction) => !(await chatAction({ id, action })).error

  return {
    makeTask: (comment: Persisted<Comment>) => run(comment.id, 'make-task'),
    /** Undo of "Not a task": the server restores the task as it was, its done state included */
    restoreTask: (comment: Persisted<Comment>) => run(comment.id, 'restore-task'),
    notTask: (comment: Persisted<Comment>) => run(comment.id, 'not-task'),
    tick: (comment: Persisted<Comment>) => run(comment.id, 'tick'),
    untick: (comment: Persisted<Comment>) => run(comment.id, 'untick'),
    like: (comment: Persisted<Comment>) => run(comment.id, 'like'),
    unlike: (comment: Persisted<Comment>) => run(comment.id, 'unlike'),
    resolveThread: (thread: Persisted<Chat>) => run(thread.id, 'resolve'),
    reopenThread: (thread: Persisted<Chat>) => run(thread.id, 'reopen'),
  }
}
